import './List.scss';
import React from 'react';
import {connect} from 'react-redux';
import {Button, Popconfirm,Popover, Input, Card, Breadcrumb, Icon, message, Pagination} from 'antd';
import moment from 'moment';
import Info from '../Detail/Info';
import FindUserHOC from '../Order/FindUserHOC';
import ajaxUtil from '../../util/ajax';
import {style} from '../../util/image';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import AddVideo from './AddVideo';

const {ajax, ajaxv2, DOMAIN_CURRENT} = ajaxUtil;

export const STATUS_MAP = {
  'wait':'待配置',
  'config':'待直播',
  'play':'正在直播',
  'stop':'暂停直播',
  'complete':'直播完成，待回放',
  'directend':'直播完成，暂无回放',
  'rollback':'回放成功'
};

export const getStatusMap = (key)=>{
  return STATUS_MAP[key];
}

const CardCover = (props)=>{
  let {data, onDelete, onEdit} = props;
  let {thumb = '', status = ''} = data;
  return <div className="video-card-item">
    <div className={"video-card-item-type status-" + status}>{getStatusMap(status)}</div>
    <img src={style(thumb, 'wx_750_420')} />
  </div>;
};

const CardItem = (props)=>{
  let {data, findUserById, onDelete, onEdit, orderid, galleryid} = props;
  const {livesource = {}} = data;
  let {begin_at, end_at, title} = livesource;

  const onPlay = ()=>{
    window.location.href = `/page/video/control/${data.source}?orderid=${orderid}&galleryid=${galleryid}`;
  };

  return <Card
    cover={<CardCover data={data} onDelete={onDelete} onEdit={onEdit} />}
    actions={[
      !window.actionFor('medium-video-query', 'boolean') ? <a onClick={onPlay}>详情</a> : null,
      !window.actionFor('medium-video-edit', 'boolean') ? <a onClick={()=>{
        onEdit(data.livesource, data.id);
      }}>编辑</a> : null,
      !window.actionFor('medium-video-delete', 'boolean') ? <Popconfirm
        title="确认删除此直播视频么？"
        onConfirm={()=>{
          onDelete(data.livesource, data.id);
        }}
      >
        <a>删除</a>
      </Popconfirm> : null,
    ].filter(Boolean)}
  >
    <Card.Meta title={title} description={
      <React.Fragment>
        {begin_at ? <p>开始时间：{moment(begin_at).format('YYYY-MM-DD HH:mm')}</p> : null}
        {end_at ? <p>结束时间：{moment(end_at).format('YYYY-MM-DD HH:mm')}</p> : null}
      </React.Fragment>
    } />
  </Card>;
};

class List extends React.Component{
    state = {
    };

    constructor(props) {
        super(props);

        this.state = {
            record:null,
            order:{},
            page:1,
            pagesize:50,
            total:0,
            list:[],
            search:""
        };
    }

    componentDidMount() {
      this.getOrder().then(()=>{
        this.getList();
      });
    }

    onClose = ()=>{
      this.setState({
        record:null
      })
    }

    getOrder = ()=>{
      return new Promise((resolve)=>{
        let {match} = this.props;
        let {params = {}} = match;

        if(params && params.orderid) {
          ajax({
            url:DOMAIN_CURRENT + '/api/order/' + params.orderid
          }).then(res=>{
            this.setState({
              order:res
            }, resolve);
          });
        }else {
          resolve();
        }
      });
    }

    getList = ()=>{
      let {page, search, total, list, pagesize} = this.state;
      let {match} = this.props;
      let {params = {}} = match;
      let {orderid, galleryid} = params;

      let searchData = {
        page,
        type:'live'
      };
      if(galleryid) {
        searchData.gallery_id = galleryid;
      }
      if(search) {
        searchData.search = search;
      }

      ajaxv2({
        url:DOMAIN_CURRENT + '/api/v2/gallerymedium/list',
        method:'GET',
        data:searchData
      }).then(res=>{
        let {items, total} = res;

        // 批量获取
        let ids = (items && items.length ) ? items.map(it=>it.source) : [];
        if(ids && ids.length) {
          ajaxv2({
            url:DOMAIN_CURRENT + '/api/v2/live/source/list',
            method:'GET',
            data:{
              gallery_id:galleryid,
              page_size:100
            }
          }).then(livelist=>{
            let livemap = {};
            if(livelist && livelist.items && livelist.items.length) {
              livelist.items.forEach(it=>{
                livemap[String(it.id)] = it;
              });
            }

            items = items.map(it=>{
              let live = livemap[String(it.source)];
              if(live) {
                it.status = live.status;
                it.name = live.title;
                it.thumb = live.cover_img;
                it.livesource = live;
                return it;
              }else {
                return it;
              }
            });

            this.setState({
              list:items,
              total
            });
          });
        }else {
          this.setState({
            list:items,
            total
          });
        }
      });

      // ajaxv2({
      //   url:DOMAIN_CURRENT + '/api/v2/live/source/list',
      //   method:'GET',
      //   data:searchData
      // }).then(res=>{
      //   let {items, total} = res;
      //
      //   this.setState({
      //     list:items,
      //     total
      //   });
      // });
    }

    onDelete = (data, medium_id)=>{
      if(data && data.id) {
        return ajax({
          url:DOMAIN_CURRENT + '/api/v2/live/source/del/' + data.id,
          method:'POST'
        }).then(res=>{
          if(res) {
            // 删除掉gallery_medium
            debugger;
            ajaxv2({
              url:DOMAIN_CURRENT + '/api/v2/gallerymedium/del/' + medium_id,
              method:'POST'
            }).then(()=>{
              message.success('删除成功');
              let {list} = this.state;
              list = list.filter(it=>it.id != medium_id);
              this.setState({
                list
              });
            });
          }else {
            message.error('删除失败');
          }
        })
      }
    }

    onEdit = (data, medium_id)=>{
      data.medium_id = medium_id;
      this.setState({
        record:data
      });
    }

    onSubmit = (data)=>{
      // return ajaxv2({
      //   url:DOMAIN_CURRENT + (data && data.id ? `/api/v2/gallerymedium/saveone/${data.id}` : `/api/v2/gallerymedium/add`),
      //   method:'POST',
      //   data
      // }).then(res=>{
      let medium_id = data.medium_id;
      delete data.medium_id

      return ajaxv2({
        url:DOMAIN_CURRENT + (data && data.id ? '/api/v2/live/source/upone/' + data.id : '/api/v2/live/source/add'),
        method:'POST',
        data
      }).then(res=>{
        if(res && res.id * 1) {
          let promise = [];
          if(data.id * 1) {
            message.success('编辑成功');
            // message.warning('每次编辑直播时间后，直播状态会回到“待配置”，请勿必前往监控界面生成最新的推流地址');

            let {record} = this.state;
            if(record.begin_at != data.begin_at || record.end_at != data.end_at) {
              promise.push(ajaxv2({
                url:DOMAIN_CURRENT + '/api/v2/aliyun/live/'+res.id+'/pushurl',
                method:'POST'
              }));
            }
          }else {
            message.success('添加成功');

            promise.push(ajaxv2({
              url:DOMAIN_CURRENT + '/api/v2/aliyun/live/'+res.id+'/pushurl',
              method:'POST'
            }));
          }

          // 原有逻辑之外，还要添加gallery_medium的新增或者修改
          promise.push(ajaxv2({
            url:DOMAIN_CURRENT + (medium_id ? `/api/v2/gallerymedium/saveone/${medium_id}` : `/api/v2/gallerymedium/add`),
            method:'POST',
            data:{
              type:'live',
              source:res.id,
              desc:data.title,
              status:'wait',
              gallery_id:Number(data.gallery_id),
              thumb:data.cover_img
            }
          }));

          return Promise.all(promise).then(()=>{
            // this.setState({
            //   page:1
            // }, this.getList);
            this.getList();

            return res;
          })
        }else {
          message.error('提交失败');
          throw(new Error());
        }
      });
    }

    onPageChange = (e)=>{
      this.setState({
        page:e
      }, this.getList);
    }

    render(){
      let {record, page, list, total, search, order} = this.state;

      let {match} = this.props;
      let {params = {}} = match;

      const {orderid, galleryid} = params;

      return (
        <div className="list-publish video-list">
          <div className="video-search">
            <div>
              <span style={{fontSize:14,fontWeight:'bold'}}>当前活动：{order ? order.name : '--'}</span>
            </div>

            <div className="video-filter">
              <Button {...window.actionFor('medium-video-create')} type="primary" onClick={()=>{
                this.setState({
                  record:{
                    type:"live",
                    status:"config",
                    order_id:order.id,
                    gallery_id:galleryid || "",
                    consumer_id:order.consumerid,
                    begin_time:moment(order.actionstarttime * 1).isValid() ? moment(order.actionstarttime * 1).format('YYYY-MM-DD HH:mm:ss') : '',
                    end_time:moment(order.actionendtime * 1).isValid() ? moment(order.actionendtime * 1).format('YYYY-MM-DD HH:mm:ss') : ''
                  }
                })
              }} style={{marginRight:10}}>新建直播视频</Button>
              <Input.Search placeholder="请输入视频名称" onSearch={(e)=>{
                this.setState({
                  search:e,
                  page:1
                }, this.getList)
              }} />
            </div>
          </div>
          <div>
            <div className="video-list-wrapper">
              {(list || []).map(it=>{
                return <CardItem orderid={orderid} galleryid={galleryid} onDelete={this.onDelete} onEdit={this.onEdit} key={it.id} findUserById={this.props.findUserById} data={it} />
              })}
            </div>
            <div className="video-list-pagination">
              <Pagination onChange={this.onPageChange} current={this.state.page} total={this.state.total} pageSize={this.state.pagesize} />
            </div>
          </div>
          {record ? <AddVideo key={record ? record.id : 0} data={record} onSubmit={this.onSubmit} onClose={this.onClose} /> : null}
        </div>
      )
    }
}

export default connect()(FindUserHOC(List));



// WEBPACK FOOTER //
// ./src/components/Video/List.js